import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';
import { EditTargetsProvider } from '@/contexts/edit-targets-context';
import { NoHiringGoalDialogProvider } from '@/contexts/no-hiring-goal-dialog-context';
import { OpeningProvider } from '@/contexts/opening-context';
import { useNavigationPaths } from '@/hooks/use-navigation-paths';

import { Overview } from './overview';

export function OpeningDetails() {
  const intl = useIntl();
  const { dashboardPath } = useNavigationPaths();

  return (
    <main className="flex h-screen flex-1 flex-col gap-4 px-6 py-2">
      <Header
        headers={[
          {
            title: intl.formatMessage({
              defaultMessage: 'Dashboard',
              description:
                'Breadcrumb back-link label returning to the sourcing home',
            }),
            path: dashboardPath,
          },
          {
            title: intl.formatMessage({
              defaultMessage: 'Opening details',
              description:
                'Breadcrumb: current page is one job’s sourcing overview',
            }),
          },
        ]}
      />

      <ErrorStateFallback>
        <NoHiringGoalDialogProvider>
          <EditTargetsProvider>
            <OpeningProvider>
              {/* `Overview` and each route page (Channels/Funnel) own their
                  own Suspense boundary so they can render and load in parallel
                  with their own skeletons rather than the whole body going
                  blank. */}
              <Overview />
              <Outlet />
            </OpeningProvider>
          </EditTargetsProvider>
        </NoHiringGoalDialogProvider>
      </ErrorStateFallback>
    </main>
  );
}
